import {STATE_LOGIN} from './components/AuthForm';
import {EmptyLayout, LayoutRoute, MainLayout} from './components/Layout';
import AuthPage from './pages/AuthPage';
// pages
import DashboardPage from './pages/DashboardPage';
import React from 'react';
import componentQueries from 'react-component-queries';
import {Redirect, Switch} from 'react-router-dom';
import './styles/reduction.css';
import AdminPage from "./pages/admin/AdminPage";
import ManagerPage from "./pages/manager/ManagerPage";
import {bindActionCreators} from "redux";
import {login} from "./actions/userAction";
import connect from "react-redux/es/connect/connect";
import {withRouter} from "react-router";
import AdminFormPage from "./pages/admin/AdminFormPage";
import AdminDetailPage from "./pages/admin/AdminDetailPage";
import ManagerFormPage from "./pages/manager/ManagerFormPage";
import ManagerDetailPage from "./pages/manager/ManagerDetailPage";
import AuditorFormPage from "./pages/auditor/AuditorFormPage";
import AuditorDetailPage from "./pages/auditor/AuditorDetailPage";
import AuditorPage from "./pages/auditor/AuditorPage";
import CompanyDetailPage from "./pages/company/CompanyDetailPage";
import CompanyFormPage from "./pages/company/CompanyFormPage";
import CompanyPage from "./pages/company/CompanyPage";
import UserPage from "./pages/user/UserPage";
import UserDetailPage from "./pages/user/UserDetailPage";
import UserFormPage from "./pages/user/UserFormPage";
import AuditPage from "./pages/audit/AuditPage";
import AuditFormPage from "./pages/audit/AuditFormPage";

const user = localStorage.getItem('Gein[user]');
let isAuthenticated = Boolean(user);

class App extends React.Component {

    componentDidMount() {
        if (isAuthenticated && !this.props.user)
            this.props.storeUser(JSON.parse(user));
    }

    render() {
        return (
            <Switch>
                {this.props.location.pathname === '/login' && this.props.id && <Redirect to="/"/>}
                <LayoutRoute
                    exact
                    path="/login"
                    layout={EmptyLayout}
                    component={props => (
                        <AuthPage {...props} authState={STATE_LOGIN}/>
                    )}
                />
                {/*Private Routes*/}
                <LayoutRoute
                    exact
                    path="/"
                    layout={MainLayout}
                    component={DashboardPage}
                />
                <LayoutRoute
                    exact
                    path="/admins"
                    layout={MainLayout}
                    component={AdminPage}
                />
                <LayoutRoute
                    exact
                    path="/admins/detail/:admin_id"
                    layout={MainLayout}
                    component={AdminDetailPage}
                />
                <LayoutRoute
                    exact
                    path="/admins/form"
                    layout={MainLayout}
                    component={AdminFormPage}
                />
                <LayoutRoute
                    exact
                    path="/admins/form/:admin_id"
                    layout={MainLayout}
                    component={AdminFormPage}
                />
                <LayoutRoute
                    exact
                    path="/managers"
                    layout={MainLayout}
                    component={ManagerPage}
                />
                <LayoutRoute
                    exact
                    path="/managers/detail/:manager_id"
                    layout={MainLayout}
                    component={ManagerDetailPage}
                />
                <LayoutRoute
                    exact
                    path="/managers/form"
                    layout={MainLayout}
                    component={ManagerFormPage}
                />
                <LayoutRoute
                    exact
                    path="/managers/form/:manager_id"
                    layout={MainLayout}
                    component={ManagerFormPage}
                />
                <LayoutRoute
                    exact
                    path="/auditors"
                    layout={MainLayout}
                    component={AuditorPage}
                />
                <LayoutRoute
                    exact
                    path="/auditors/detail/:auditor_id"
                    layout={MainLayout}
                    component={AuditorDetailPage}
                />
                <LayoutRoute
                    exact
                    path="/auditors/form"
                    layout={MainLayout}
                    component={AuditorFormPage}
                />
                <LayoutRoute
                    exact
                    path="/auditors/form/:auditor_id"
                    layout={MainLayout}
                    component={AuditorFormPage}
                />
                <LayoutRoute
                    exact
                    path="/users"
                    layout={MainLayout}
                    component={UserPage}
                />
                <LayoutRoute
                    exact
                    path="/users/detail/:user_id"
                    layout={MainLayout}
                    component={UserDetailPage}
                />
                <LayoutRoute
                    exact
                    path="/users/form"
                    layout={MainLayout}
                    component={UserFormPage}
                />
                <LayoutRoute
                    exact
                    path="/users/form/:user_id"
                    layout={MainLayout}
                    component={UserFormPage}
                />
                <LayoutRoute
                    exact
                    path="/companies"
                    layout={MainLayout}
                    component={CompanyPage}
                />
                <LayoutRoute
                    exact
                    path="/companies/detail/:company_id"
                    layout={MainLayout}
                    component={CompanyDetailPage}
                />
                <LayoutRoute
                    exact
                    path="/companies/form"
                    layout={MainLayout}
                    component={CompanyFormPage}
                />
                <LayoutRoute
                    exact
                    path="/companies/form/:company_id"
                    layout={MainLayout}
                    component={CompanyFormPage}
                />
                <LayoutRoute
                    exact
                    path="/audits"
                    layout={MainLayout}
                    component={AuditPage}
                />
                <LayoutRoute
                    exact
                    path="/audits/form"
                    layout={MainLayout}
                    component={AuditFormPage}
                />
                <Redirect to="/"/>
            </Switch>
        );
    }
}

const query = ({width}) => {
    if (width < 575) {
        return {breakpoint: 'xs'};
    }

    if (576 < width && width < 767) {
        return {breakpoint: 'sm'};
    }

    if (768 < width && width < 991) {
        return {breakpoint: 'md'};
    }

    if (992 < width && width < 1199) {
        return {breakpoint: 'lg'};
    }

    if (width > 1200) {
        return {breakpoint: 'xl'};
    }

    return {breakpoint: 'xs'};
};

const mapStateToProps = state => {
    return {user: state.userReducer.user};
};

const mapDispatchToProps = dispatch =>
    bindActionCreators({storeUser: login}, dispatch);

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(App));
componentQueries(query)(App);



// WEBPACK FOOTER //
// ./src/App.js